import {Component} from "@angular/core";

@Component({
    selector: "fui-sections",
    styleUrls: ["./sections.component.scss"],
    templateUrl: "./sections.component.html",
    standalone: false
})
export class FUISectionsComponent {
}
